import { useEffect } from "react"
import { useGrowthBook } from "@growthbook/growthbook-react"
import { startExperimentTracking } from "./experimentTracking"

const GrowthBookInit = () => {
  const growthbook = useGrowthBook()

  useEffect(() => {
    if (!growthbook) return

    // Chargement des features en mode streaming
    growthbook.init({ streaming: true })

    startExperimentTracking(growthbook)

    // Cleanup
    return () => {
      growthbook.destroy()
    }
  }, [growthbook])

  return null // Ce composant ne rend rien
}

export default GrowthBookInit
